import { FuzzyComparePlainObject } from './fuzzyCompare.plainObject';
import { MultiInputStreamBasePlainObject } from './multiInputStreamBase.plainObject';

export class JoinPlainObject extends MultiInputStreamBasePlainObject {
    public joinType: string;
    public matchType: string = 'exact';
    public crossExpression: string;
    public ignoreSpaces: boolean;
    public scoreColumn: string;
    public fuzzyCompareExpressions: FuzzyComparePlainObject[] = [];
}
